'use strict';

exports.__esModule = true;

var _download = require('../../images/download.svg');

Object.defineProperty(exports, 'downloadSvg', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_download).default;
  }
});

var _share = require('../../images/share.svg');

Object.defineProperty(exports, 'shareSvg', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_share).default;
  }
});

var _facebook = require('../../images/facebook.svg');

Object.defineProperty(exports, 'facebookSvg', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_facebook).default;
  }
});

var _twitter = require('../../images/twitter.svg');

Object.defineProperty(exports, 'twitterSvg', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_twitter).default;
  }
});

var _add = require('../../images/add.svg');

Object.defineProperty(exports, 'addSvg', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_add).default;
  }
});

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }


//////////////////
// WEBPACK FOOTER
// ../thicket/packages/thicket-elements/lib/Icons/index.js
// module id = 121
// module chunks = 2